export const validationMessages = {
  firstName: 'Enter a valid first name',
  lastName: 'Enter a valid last name',
  email: 'Enter a valid email address (example: name@email.com)',
  phone: 'Enter a valid 10-digit phone number',
  birthDate: 'Enter a valid date of birth',
  birthDateUnder18: 'You must be at least 18 years old to apply',
  ssn: 'Enter a valid 9-digit Social Security number',
  otp: 'That code is incorrect. Please try again.',
  gpa: 'Enter your GPA between 0.00 and 4.00',
  yearlyIncome: 'Enter your total yearly income before taxes',
  optional: 'Optional',
  rentMin: (label = 'Amount') => `${label} must be at least $100`,
  rentMax: (label = 'Amount') => `${label} can’t be more than $25,000`,
};

export const rentAmountMessage = (value, label = 'Amount') => {
  if (value === 0 || (value && value < 100)) {
    return validationMessages.rentMin(label);
  }
  if (value && value > 25000) {
    return validationMessages.rentMax(label);
  }
  return '';
};
